export default function () {
  const el = document.querySelector('.spotlight-text--wrapper');

  if (!el) {
    return;
  }

}